module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.races) ? _c('div', [_vm._v("\n        loading races...\n      ")]) : _vm._e(), _vm._v(" "), (_vm.races) ? _c('div', _vm._l((_vm.races), function(race) {
    return _c('div', {
      key: race.ve,
      staticClass: "race"
    }, [_vm._v("\n          " + _vm._s(race.ve) + "\n        ")])
  }), 0) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7613400e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Race.vue
// module id = 237
// module chunks = 1